/* Sunkissed (Nov 1 2026): "Complete the set" in the bag (drawer and bag page).
   When a top is in the bag without its matching bottom (or the other way round), offer the matching piece
   in the same print, with its sizes. Matching by title: Le Triangle top/bottom, Le Sporty top/bottom,
   Le Bandeau top with Le Bas Cheeky bottom, same colour after the " - ". Uses the same row look as the towel offer. */
(function () {
  'use strict';
  var BOX = 'sk-cts-offer', list = null, loading = null, busy = false, pick = {};
  function j(u) { return fetch(u).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function parse(t) {
    t = (t || '').toLowerCase(); if (/\bset\b/.test(t)) return null;
    var sty = /triangle/.test(t) ? 'tri' : /sporty/.test(t) ? 'spo' : (/bandeau/.test(t) || /bas cheeky/.test(t)) ? 'ban' : '';
    var part = /\btop\b/.test(t) ? 'top' : /bottom/.test(t) ? 'bottom' : '';
    if (!sty || !part || t.indexOf(' - ') < 0) return null;
    var col = t.split(' - ').pop().replace(/nevy/g, 'navy').replace(/[^a-z0-9]/g, '');
    return { sty: sty, part: part, col: col };
  }
  function money(c) { return window.SK_INTL ? SK_INTL.money(c) : ('$' + (c / 100).toFixed(2)).replace('.00', ''); }
  function img(p) { var s = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || ''; if (s && s.indexOf('//') === 0) s = 'https:' + s; return s ? s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=200' : ''; }
  function load() {
    if (list) return Promise.resolve(list); if (loading) return loading;
    loading = j('/collections/separates/products.json?limit=250').then(function (d) { list = (d && d.products) || []; return list; });
    return loading;
  }
  function remove() { Array.prototype.forEach.call(document.querySelectorAll('.' + BOX), function (e) { e.parentNode.removeChild(e); }); }
  function want(cart) {
    var inBag = {}, need = [];
    cart.items.forEach(function (it) { inBag[it.handle] = 1; var k = parse(it.product_title); if (k) need.push(k); });
    var have = {}; cart.items.forEach(function (it) { var k = parse(it.product_title); if (k) have[k.sty + k.part + k.col] = 1; });
    var out = [];
    need.forEach(function (k) {
      var other = k.part === 'top' ? 'bottom' : 'top'; if (have[k.sty + other + k.col]) return;
      for (var i = 0; i < list.length; i++) {
        var p = list[i], q = parse(p.title);
        if (q && !inBag[p.handle] && q.sty === k.sty && q.part === other && q.col === k.col && p.variants.some(function (v) { return v.available; })) {
          if (out.indexOf(p) < 0) out.push(p); break;
        }
      }
    });
    return out.slice(0, 2);
  }
  function name(p) { var t = p.title.split(' - '); return { n: t[0].replace(' Bikini', ''), c: t.length > 1 ? t[t.length - 1] : '' }; }
  function row(p) {
    var nm = name(p), av = p.variants.filter(function (v) { return v.available; });
    var sel = pick[p.handle] || null;
    var v = sel ? p.variants.filter(function (x) { return String(x.id) === String(sel); })[0] : null;
    var price = (v || av[0]).price; price = typeof price === 'string' ? Math.round(parseFloat(price) * 100) : price;
    return '<div class="sk-trow" data-cts="' + p.handle + '">' +
      (img(p) ? '<img class="sk-trow__img" src="' + img(p) + '" alt="">' : '') +
      '<div class="sk-trow__x"><b>' + nm.n + '</b><div class="sk-trow__m">' + nm.c + ' · ' + money(price) + ' · save $9 as a set</div>' +
      '<div class="sk-cts__sizes">' + p.variants.map(function (x) {
        return '<button type="button" data-cts-v="' + x.id + '"' + (x.available ? '' : ' disabled') + ' aria-pressed="' + (String(x.id) === String(sel)) + '">' + x.title + '</button>';
      }).join('') + '</div></div>' +
      '<button type="button" class="sk-trow__add" data-cts-add>' + (v ? 'Add ' + v.title : 'Pick size') + '</button></div>';
  }
  function render(cart) {
    var holder = document.querySelectorAll('cart-items[data-items-holder], [data-items-holder]');
    var items = want(cart); if (!items.length || !holder.length) { remove(); return; }
    Array.prototype.forEach.call(holder, function (h) {
      var el = h.querySelector('.' + BOX);
      if (!el) { el = document.createElement('div'); el.className = BOX; el.style.cssText = 'display:block;width:100%;box-sizing:border-box'; var t = h.querySelector('.sk-towel-offer'); if (t) h.insertBefore(el, t); else h.appendChild(el); }
      el.innerHTML = items.map(row).join('');
      Array.prototype.forEach.call(el.querySelectorAll('[data-cts-v]'), function (b) {
        b.addEventListener('click', function () { pick[this.closest('[data-cts]').getAttribute('data-cts')] = this.getAttribute('data-cts-v'); render(cart); });
      });
      Array.prototype.forEach.call(el.querySelectorAll('[data-cts-add]'), function (b) {
        b.addEventListener('click', function () {
          var r = this.closest('[data-cts]'), id = pick[r.getAttribute('data-cts')];
          if (!id) { r.classList.add('sk-cts--nudge'); setTimeout(function () { r.classList.remove('sk-cts--nudge'); }, 900); return; }
          if (busy) return; busy = true; var btn = this; btn.textContent = 'Adding...';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
            .then(function (res) { return res.json().then(function (x) { return { ok: res.ok, x: x }; }); })
            .then(function (res) { busy = false; if (res.ok) { remove(); document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true })); if (/\/cart\b/.test(location.pathname)) setTimeout(function () { location.reload(); }, 300); } else btn.textContent = (res.x && res.x.description) || 'Sold out'; })
            .catch(function () { busy = false; btn.textContent = 'Try again'; });
        });
      });
    });
  }
  function update() {
    if (!document.querySelector('.cart__item[data-item]')) { remove(); return; }
    j('/cart.js').then(function (cart) { if (!cart || !cart.items.length) { remove(); return; } load().then(function () { render(cart); }); });
  }
  ['theme:cart:refresh', 'theme:cart:change', 'theme:cart:update', 'theme:cart-drawer:open', 'theme:product:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(update, 450); setTimeout(update, 1500); });
  });
  var mo = new MutationObserver(function (m) {
    if (!m.some(function (x) { var t = x.target; return !(t.closest && (t.closest('.sk-towel-offer') || t.closest('.' + BOX) || t.closest('.set-offer-inline'))); })) return;
    clearTimeout(mo.t); mo.t = setTimeout(update, 350);
  });
  function go() { var d = document.querySelector('cart-drawer, [data-cart-drawer], .drawer--cart'); if (d) mo.observe(d, { childList: true, subtree: true }); update(); }
  if (document.readyState !== 'loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();

/* Nov 1 2026 (Ben, upgrade 3): estimated arrival right above Check out, in the drawer and on the bag page.
   Same rule as the product page: order by 2pm ET ships that business day, arrives 3 business days later. US shoppers only. */
(function () {
  'use strict';
  if (window.Shopify && Shopify.country && Shopify.country !== 'US') return;
  function eta() {
    var now = new Date(), et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    var biz = function (d) { return d.getDay() !== 0 && d.getDay() !== 6; };
    var today = biz(et) && et.getHours() < 14;
    var ship = new Date(et); if (!today) { ship.setDate(ship.getDate() + 1); while (!biz(ship)) ship.setDate(ship.getDate() + 1); }
    var arr = new Date(ship), n = 0; while (n < 3) { arr.setDate(arr.getDate() + 1); if (biz(arr)) n++; }
    var tmr = new Date(et); tmr.setDate(tmr.getDate() + 1);
    var when = today ? 'Order by 2pm ET, ships today' : (ship.toDateString() === tmr.toDateString() ? 'Ships tomorrow' : 'Ships ' + ship.toLocaleDateString('en-US', { weekday: 'long' }));
    return { a: when, b: 'Est. arrival ' + arr.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) };
  }
  function place() {
    var e = eta(), html = '<span>' + e.a + '</span><span>' + e.b + '</span>';
    document.querySelectorAll('cart-drawer .cart__checkout:not([name="update"]), main .cart__checkout[name="checkout"]').forEach(function (btn) {
      var anchor = btn.closest('.cart__buttons') || btn;
      var row = anchor.previousElementSibling;
      if (!row || !row.classList.contains('sk-bag-eta')) { row = document.createElement('p'); row.className = 'sk-bag-eta'; anchor.parentNode.insertBefore(row, anchor); }
      if (row.innerHTML !== html) row.innerHTML = html;
    });
    document.querySelectorAll('.sk-bag-eta').forEach(function (r) { var n = r.nextElementSibling; if (!n || !(n.matches('.cart__buttons') || n.matches('.cart__checkout'))) r.remove(); });
  }
  var t; function soon() { clearTimeout(t); t = setTimeout(place, 120); }
  document.addEventListener('DOMContentLoaded', place); window.addEventListener('load', place);
  ['cart:updated', 'cart:refresh', 'theme:cart:change', 'theme:cart:refresh'].forEach(function (ev) { document.addEventListener(ev, soon); });
  if (window.MutationObserver) new MutationObserver(function () { var b = document.querySelectorAll('cart-drawer .cart__checkout:not([name="update"]), main .cart__checkout[name="checkout"]').length; if (b !== document.querySelectorAll('.sk-bag-eta').length) soon(); }).observe(document.body, { childList: true, subtree: true });
})();
